import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import ActionLink from '../../components/ActionLink';
import DivContainer from '../../components/DivContainer';
import InputDropdownComponent from '../../components/inputs/InputDropdownComponent';
import InputTextComponent from '../../components/inputs/InputTextComponent';
import BaseUserDetailsContainer from '../../baseContainers/BaseUserDetailsContainer';
import EmployeeService from '../../services/EmployeeService';
import { t } from 'i18next';
import SettingService from '../../services/SettingService';
import Constants from '../../utils/constants';
import InputAutocompleteComponent from '../../components/inputs/InputAutocompleteComponent';
import LeaveRequestService from '../../services/LeaveRequestService';
import LeaveRequestModel from '../../model/LeaveRequestModel';
import moment from 'moment';
import InputCalendarRangeComponent from '../../components/inputs/InputCalendarRangeComponent';
import YesNoDialog from '../../components/YesNoDialog';
import { TabView } from 'primereact/tabview';
import LogEntryListContainer from '../LogEntryListContainer';
import { TabPanel } from 'primereact/tabview';
import LeaveRequestViewContainer from './LeaveRequestViewContainer';
import UserAbsenceReasonService from '../../services/UserAbsenceReasonService';
import { withRouter } from "react-router-dom";

class LeaveRequestContainer extends BaseUserDetailsContainer {
    constructor(props) {
        super(props, new LeaveRequestService());
        this.settingsService = new SettingService()
        this.employeeService = new EmployeeService()
        this.state = {
            confirmationDialog: false,
            elementId: this.props.elementId,
            element: new LeaveRequestModel(),
            loading: false,
            employee: undefined,
            filteredEmployees: undefined,
            leaveRequestTypes: undefined,
            activeIndex: 0,
        };

        this.handleOpenAcceptationDialog = this.handleOpenAcceptationDialog.bind(this);
        this.handleOpenRejectionDialog = this.handleOpenRejectionDialog.bind(this);
        this.handleOpenDeleteDialog = this.handleOpenDeleteDialog.bind(this);
        this.absenceReasonsService = new UserAbsenceReasonService()

    }

    initBeforeSetElement() {
        if (this.readCookie('leaveRequestViewCalendar') !== undefined && this.readCookie('leaveRequestViewCalendar') !== null) {
            this.getAvailableDays()
        }
        
        this.absenceReasonsService
            .getList({ firstResult: 0, maxResults: 1000, sortField: 'id', sortAsc: true, forLeave: true })
            .then((x) => {
                this.setState({
                    leaveAbsenceReason: x.content
                })
            }).catch((err) => {
                this.showErrorMessage('Nie udało się pobrać listy typow wnioskow urlopowych');
            })
    }

    getAllEmployees(query) {
        this.employeeService
            .searchAllEmployees(query)
            .then((employees) => this.setState({ filteredEmployees: employees }))
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy pracowników');
            });
    }

    getAvailableDays() {
        const { element } = this.state;
                const {currentUser} = this.props;
        const employeeId = element.employee !== undefined ? element.employee?.id : currentUser.subId;

            this.service.getAvailableDays(employeeId)
            .then(data => {
                this.setState((prevState) => ({
                    element: {
                        ...prevState.element,
                        annualLeaveTotalDays: data.annualLeaveTotalDays,
                        annualLeaveLeftDays: data.annualLeaveLeftDays,
                        annualLeaveOverdueDays: data.annualLeaveOverdueDays,
                        annualLeaveUsedDays: data.annualLeaveUsedDays

                    },
                }));
            })
   
    }

    getAddSucces() {
        const { t } = this.props;
        return t('leaveRequest.addSuccess');
    }

    getUpdateSucces() {
        const { t } = this.props;
        return t('leaveRequest.updateSuccess');
    }

    updateElement(data) {
        if (data.dateFrom) {
            data.dateFrom = moment(data.dateFrom).toDate();
        }
        if (data.dateTo) {
            data.dateTo = moment(data.dateTo).toDate();
        }
        this.setState(
            {
                element: LeaveRequestModel.copy(data),
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }

    getBackUrl() {
        let backUrlFromCookie = this.readCookie('leaveRequestViewCalendar');
        let backUrl = this.props.backUrl;
        if (backUrlFromCookie !== undefined && backUrlFromCookie !== '' && backUrlFromCookie !== null) {
            return backUrlFromCookie;
        } else return backUrl;
    }

    afterUpdateSuccess(response) {
        this.blockUi();
        this.persistMessage('success', '', this.getUpdateSucces(response));
        window.location.href = this.getBackUrl(); //powrot do listy
        // powrot do szczegolow
        // const detailsUrl = `${viewUrl}${element.id}`;
        // window.location.href = detailsUrl;
        this.refreshCurrentElement();
    }

    handleGoBack(e) {
        e.preventDefault();
        this.blockUi();
        window.location.href = this.getBackUrl();
    }

    renderBackLink() {
        return (
            <ActionLink
                rendered={true}
                label={this.getBackLabel()}
                className='p-link float-right'
                handleClick={this.handleGoBack.bind(this)}
                variant='green'
                iconName='mdi-arrow-left'
                iconSide='left'
                iconSize='xs'
                iconColor='green'
            />
        );
    }

    initAfterSetElement() {
        super.initAfterSetElement();
    }

    handleFormSubmit(event) {
        if (event !== undefined) {
            event.preventDefault();
        }
        if (this.validator.allValid()) {
            this.blockUi(this.handleValidForm);
        } else {
            this.validator.showMessages();
            // rerender to show messages for the first time
            this.scrollToError = true;
            this.forceUpdate();
        }
    }
    prepareElement(element) {
        if (element.rejectionReason === null) {
            element.rejectionReason = undefined;
        }
        if (element.leftDaysNumber === null) {
            element.leftDaysNumber = undefined;
        }
        if (element.status === null) {
            element.status = undefined;
        }
        if (element.dateFrom !== null) {
            element.dateFrom = moment(element.dateFrom).format(Constants.DATE_GET_REQUEST_FORMAT);
        }
        if (element.dateTo !== null) {
            element.dateTo = moment(element.dateTo).format(Constants.DATE_GET_REQUEST_FORMAT);
        }
        element.status = undefined;


        return element;
    }
    afterAcceptLeaveRequestSuccess(response) {
        const {backUrl} = this.props;
        this.blockUi();
        this.persistMessage('success', '', t('leaveRequest.acceptationSuccess'));
        window.location.href = this.getBackUrl();
        this.refreshCurrentElement();
    }

    handleAccept() {
        const { element } = this.state;
        this.service
            .accept(element.id, element.leftDaysNumber)
            .then((response) => {
                this.handleCloseConfirmationDialog();
                this.afterAcceptLeaveRequestSuccess();
                
            })
            .catch((err) => {
                this.showErrorMessage(err.message, 10000);
                this.handleCloseConfirmationDialog();
                this.unblockUi();
                this.refreshCurrentElement();
            });
    }
   refreshCurrentElement(){
    this.setElement();
   }

    handleReject() {
        const { element } = this.state;
        this.service
            .reject(this.prepareElement(element))
            .then((response) => {
                this.showSuccessMessage(t('leaveRequest.rejectionSuccess'));
                this.handleCloseConfirmationDialog();
                this.refreshCurrentElement();
            })
            .catch((err) => {
                this.showErrorMessage(err.message, 10000);
                this.handleCloseConfirmationDialog();
                this.unblockUi();
                this.setState();
            });
    }

    handleDelete() {
        const { element } = this.state;
        this.service
            .remove(element)
            .then((response) => {
                this.showSuccessMessage(t('leaveRequest.deleteSuccess'));
                this.handleCloseConfirmationDialog();
                this.refreshCurrentElement();
                
            })
            .catch((err) => {
                this.showErrorMessage(err.message, 10000);
                this.handleCloseConfirmationDialog();
                this.unblockUi();
                this.refreshCurrentElement();
            });
    }

    afterAddSuccess(response) {
        this.blockUi();
        this.persistMessage('success', '', this.getAddSucces(response));
        window.location.href = this.getBackUrl();
    }

    create(){
        const { element } = this.state;
        const currentUser = this.authService.getProfile();
        if(this.authService.isUserInRole('ROLE_LEAVE_REQUEST_MANAGE_EDIT') && element.employee !== undefined){
            this.service
            .add(this.prepareElement(element))
            .then((response) => {
                this.afterAddSuccess(response);
            })
            .catch((err) => {
                this.showErrorMessage(err.message, 10000);
                this.unblockUi();
            });
        } else if(this.authService.isUserInRole('ROLE_LEAVE_REQUEST_EDIT') && element.employee === undefined){
            this.service
            .addOwn(this.prepareElement(element))
            .then((response) => {
                this.afterAddSuccess(response);
            })
            .catch((err) => {
                this.showErrorMessage(err.message, 10000);
                this.unblockUi();
            });
        }
    }
    update(){
        const { element } = this.state;
        const currentUser = this.authService.getProfile();
        let update = this.authService.isUserInRole('ROLE_LEAVE_REQUEST_MANAGE_EDIT') && element.employee?.id !== currentUser.subId;
        let updateOwn = this.authService.isUserInRole('ROLE_LEAVE_REQUEST_EDIT') &&element.employee?.id === currentUser.subId;
        if(update){
            this.service
            .update(this.prepareElement(element))
            .then((response) => {
                this.afterUpdateSuccess(response);
            })
            .catch((err) => {
                this.showErrorMessage(err.message, 10000);
                this.unblockUi();
            });
        } else if(updateOwn){
            this.service
            .updateOwn(this.prepareElement(element))
            .then((response) => {
                this.afterUpdateSuccess(response);
            })
            .catch((err) => {
                this.showErrorMessage(err.message, 10000);
                this.unblockUi();
            });
        }
    }

    createOrUpdate() {
        const { element } = this.state;

        if (this._isMounted) {
            if (element.id === undefined || element.id === null) {
               this.create();;
            } else {
               this.update();
            
            }
        }

    }

    handleOpenRejectionDialog() {
        this.setState({ confirmationDialog: true, dialogViewMode: 'REJECT' });
    }
    handleOpenAcceptationDialog() {
        this.service.countDaysLeaveToUse(this.state.element.id)
        .then((result)=> {  
            let res = this.state.element.annualLeaveLeftDays - result;
            this.setState((prevState) => ({ confirmationDialog: true, dialogViewMode: 'ACCEPT', element: {...prevState.element, leftDaysNumber : res} }));
        })
        .catch((err) => {
          this.setState({ confirmationDialog: true, dialogViewMode: 'ACCEPT' });
        });
       
    }
    handleCloseConfirmationDialog() {
        this.setState({ confirmationDialog: false });
    }
    handleOpenDeleteDialog() {
        this.setState({ confirmationDialog: true, dialogViewMode: 'DELETE' });
    }
    prepareFooterItems() {
        const { backUrl, cancelUrl, viewMode, editUrl, currentUser } = this.props;
        const { element } = this.state;
        let goBackUrl;
        let goEditUrl = `${editUrl}/${element.id}`;
        let canRemoveOwnLeaveRequest = element.status?.enumValue === "SUBMITTED" && element.employee?.id === currentUser.subId && ((this.authService.isUserInRole('ROLE_LEAVE_REQUEST_EDIT') && element.read === false)  || (this.authService.isUserInRole('ROLE_LEAVE_REQUEST_MANAGE_EDIT')));
        let canEditOwnLeaveRequest = element.status?.enumValue === "SUBMITTED" &&  element.employee?.id === currentUser.subId && ((this.authService.isUserInRole('ROLE_LEAVE_REQUEST_EDIT') && element.read === false)  || (this.authService.isUserInRole('ROLE_LEAVE_REQUEST_MANAGE_EDIT')));
        let canManageLeaveRequest = element.status?.enumValue === "SUBMITTED" && this.authService.isUserInRole('ROLE_LEAVE_REQUEST_MANAGE_EDIT') && element.employee?.id !== currentUser.subId;
        if (viewMode === 'NEW' || viewMode === 'VIEW') {
            goBackUrl = this.getBackUrl();
        } else {
            let backUrlFromCookie = this.readCookie('leaveRequestViewCalendar');
            goBackUrl = (backUrlFromCookie !== undefined && backUrlFromCookie !== '' && backUrlFromCookie !== null) ? this.getBackUrl() : `${cancelUrl}/${element.id}`;
        }
        if(this.state.activeIndex === 0){
            switch (viewMode) {
                case 'EDIT':
                    return [
                        { label: 'Anuluj', className: 'cancel-button white', href: goBackUrl },
                        { label: 'Zapisz', className: 'float-right', onClick: this.handleFormSubmit },
                    ];
                case 'NEW':
                    return [
                        { label: 'Anuluj', className: 'cancel-button white', href: goBackUrl },
                        { label: 'Zapisz', className: 'float-right', onClick: this.handleFormSubmit },
                    ];
                case 'VIEW':
                    if(canRemoveOwnLeaveRequest){
                        return [
                            { label: 'Edytuj', className: 'float-right', href: goEditUrl },
                            { label: 'Usuń', className: 'fullred float-right', onClick: this.handleOpenDeleteDialog }
                        ];
                    } else if(canEditOwnLeaveRequest){
                        return [
                            { label: 'Edytuj', className: 'float-right', href: goEditUrl },
                        ];
                    } else if (canManageLeaveRequest) {
                        return [
                            { label: 'Edytuj', className: 'float-right', href: goEditUrl },
                            { label: 'Zaakceptuj', className: 'float-right', onClick: this.handleOpenAcceptationDialog },
                            { label: 'Odrzuć', className: 'float-right', onClick: this.handleOpenRejectionDialog },
                        ];
                    } else {
                        return [];
                    }
    
                default:
                    return [];
            }
        } else return [];
       
    }

    isPdfButtonRendered() {
        return false;
    }


    availableDaysTemplate(emloyeeId) {
        const {element} = this.state;
        let noEmployeeSelected = this.readCookie('leaveRequestViewCalendar') === null && this.authService.isUserInRole('ROLE_LEAVE_REQUEST_MANAGE_EDIT') && (element.employee === undefined || element.employee === '' || element.employee === null);
        
        return <div>
        <div className='row profile'>
            <InputTextComponent
                id='annualLeaveTotalDays'
                name='annualLeaveTotalDays'
                label={"Liczba przysługujących dni urlopowych w bieżącym roku"}
                //label={"Liczba  dni urlopowych przysługujących w roku"}
                colClass={'col-md-6'}
                value={noEmployeeSelected  ? "-" : this.state.element.annualLeaveTotalDays}
                validator={this.validator}
                onChange={this.handleChange}
                viewMode={'VIEW'}
            />
            <InputTextComponent
                id='annualLeaveOverdueDays'
                name='annualLeaveOverdueDays'
                label={"Liczba zaległych dni urlopowych "}
                //label={"Liczba  dni urlopowych przysługujących w roku"}
                colClass={'col-md-6'}
                value={noEmployeeSelected  ? "-" : this.state.element.annualLeaveOverdueDays}
                validator={this.validator}
                onChange={this.handleChange}
                viewMode={'VIEW'}
            />
        </div>
        <div className='row profile'>
            <InputTextComponent
                id='annualLeaveUsedDays'
                name='annualLeaveUsedDays'
                label={"Liczba wykorzystanych dni urlopowych"}
                //label={"Liczba  dni urlopowych przysługujących w roku"}
                colClass={'col-md-6'}
                value={noEmployeeSelected  ? "-" : this.state.element.annualLeaveUsedDays}
                validator={this.validator}
                onChange={this.handleChange}
                viewMode={'VIEW'}
            />
            <InputTextComponent
                id='annualLeaveLeftDays'
                name='annualLeaveLeftDays'
                label={"Liczba dni pozostałych do wykorzystania"}
                colClass={'col-md-6'}
                value={noEmployeeSelected  ? "-" : this.state.element.annualLeaveLeftDays}
                validator={this.validator}
                onChange={this.handleChange}
                viewMode={'VIEW'}
            />
        </div>
        </div>
     

    }



    renderDetails() {
        let backUrlFromCookie = this.readCookie('leaveRequestViewCalendar');
        let selfNewLeaveRequest = backUrlFromCookie !== null && backUrlFromCookie !== undefined && backUrlFromCookie !== ''&& this.props.viewMode === 'NEW';
        let showCalendar = this.props.viewMode === 'VIEW' && this.state.element.status?.enumValue === 'SUBMITTED';
        return (
            <React.Fragment>
                 <TabView activeIndex={this.state.activeIndex} onTabChange={(e) => this.setState({activeIndex: e.index})}>
                <TabPanel header={t('leaveRequest.details')}>
                    <DivContainer colClass='row'>
                        <DivContainer colClass={this.props.viewMode === 'VIEW' ? 'col' : 'col col-12'}>
                        <DivContainer colClass='row'>
                             <DivContainer colClass='col-12'>

                        <div className='row profile'>
                            {selfNewLeaveRequest ?
                                null :
                                <InputAutocompleteComponent
                                    id={`employeeIdd`}
                                    name='employee'
                                    label={"Wnioskujący"}
                                    value={this.state.element.employee}
                                    dropdown
                                    forceSelection
                                    colClass='col-md-12'
                                    validator={this.validator}
                                    validators='required'
                                    showLabel={true}
                                    onChange={(a, b, c, d, e) => {
                                        this.handleChange(a, b, c, d, e)
                                    }}
                                    onAfterStateChange={
                                        () => this.getAvailableDays()
                                    }
                                    insideTable
                                    filteredList={this.state.filteredEmployees}
                                    filterList={(query) => this.getAllEmployees(query)}
                                    field='fullName'
                                    stateField={`element`}
                                    minLength={3}
                                    viewMode={this.props.viewMode === 'NEW' ? 'EDIT' : 'VIEW'}
                                    placeholder={t('search.users.placeholder')}
                                />
                            }
                           
                                <div>
                                    {this.availableDaysTemplate(this.state.employee?.id)}
                                </div>  </div>


                        <div className='row profile'>
                            <InputCalendarRangeComponent
                                id='date'
                                idFrom='dateFrom'
                                idTo='dateTo'
                                nameFrom='dateFrom'
                                nameTo='dateTo'
                                labelFrom={t('project.details.dateStart')}
                                labelTo={t('project.details.dateEnd')}
                                colClass={this.props.viewMode === 'VIEW' ? 'col-12': 'col-12'}
                                from={this.state.element.dateFrom}
                                to={this.state.element.dateTo}
                                validator={this.validator}
                                onChange={this.handleChange}
                                viewMode={this.props.viewMode}
                                showIcon={true}
                                validators={"required"}
                                validatorsTo={"not_required"}
                                
                            />
                        </div>
                        <div className='row profile'>
                            <InputDropdownComponent
                                id={`status`}
                                name='status'
                                label={'Status wniosku'}
                                colClass={showCalendar ? 'col-md-12' : 'col-md-6'}
                                value={this.state.element.status}
                                stateField={''}
                                optionLabel={'label'}
                                dataKey='enumValue'
                                onChange={this.handleChange}
                                insideTable
                                viewMode={'VIEW'}
                                validator={this.validator}
                                validators='required'
                                rendered={this.props.viewMode !== 'NEW'}
                            />

                            <InputDropdownComponent
                                id={`type`}
                                name='absenceReason'
                                label={'Typ wniosku'}
                                colClass={showCalendar ? 'col-md-12' : 'col-md-6'}
                                value={this.state.element.absenceReason}
                                options={this.state.leaveAbsenceReason}
                                optionLabel={'reason'}
                                dataKey='reason'
                                onChange={(a, b, c, d, e) => { this.handleChange(a, b, c, d, e) }}
                                insideTable
                                viewMode={this.props.viewMode}
                                validator={this.validator}
                                validators='required'
                            />
                        </div>
                        <div className='row profile'>

                            <InputTextComponent
                                id={`description`}
                                name='description'
                                label='Komentarz'
                                colClass='col-md-12'
                                value={this.state.element.description}
                                //valueView={element.car?.licensePlate}
                                dataKey='id'
                                showLabel={true}
                                onChange={this.handleChange}
                                viewMode={this.props.viewMode}
                                validator={this.validator}
                                validators='not_required|max:100'
                            />
                        </div>
                        <div className='row profile'>
                            <InputTextComponent
                                id={`rejectionReason`}
                                name='rejectionReason'
                                label='Przyczyna odrzucenia'
                                colClass={showCalendar ? 'col-md-12' : 'col-md-6'}
                                value={this.state.element.rejectionReason}
                                //valueView={element.car?.licensePlate}
                                dataKey='id'
                                showLabel={true}
                                onChange={this.handleChange}
                                viewMode={'VIEW'}
                                rendered={this.state.element.status?.enumValue === 'REJECTED'}
                            />
                        </div>


                    </DivContainer>
                </DivContainer>
                        </DivContainer>
                        {/* {this.props.viewMode === 'VIEW' && this.state.element.status?.enumValue === 'SUBMITTED' ?
                        <DivContainer colClass='col'>
                             
                            <div className='row leave-request-details'>
                                <LeaveRequestViewContainer embedded = {true}> </LeaveRequestViewContainer>
                                </div>
                        
                        </DivContainer>
                      : null  } */}
                    </DivContainer>

                </TabPanel>
                {this.state.element.employee !== undefined  && this.readCookie('leaveRequestViewCalendar') === null ?  
                                <TabPanel header={t('leaveRequest.calendarTabHeader')}>
                                <div className='row leave-request-details'>
                                    <div style={{ marginBottom:'20px'}}>Kalendarz urlopów użytkownika: <span style={{fontWeight:'700'}}>{this.state.element.employee?.fullName}</span> </div>
                                    <LeaveRequestViewContainer embedded = {true} userId={this.state.element.employee?.id}> </LeaveRequestViewContainer>
                                    </div>
                                </TabPanel> : null
            }

                {(this.props.viewMode !== 'NEW') ? (
                                <TabPanel header={t('leaveRequest.logsTabHeader')}>
                                    <LogEntryListContainer
                                        objectType='LEAVE_REQUEST'
                                        objectId={this.props.elementId}
                                        expandFilters={false}
                                        renderHeader={false}
                                    />
                                </TabPanel>
                            ) : null}
                </TabView>

                {this.state.confirmationDialog === true ?
                    <YesNoDialog
                        name='confirmation-dialog'
                        visible={this.state.confirmationDialog}
                        onChange={(type, x, target) => {
                            if (target.value) {
                                this.validator.showMessages();
                                if(this.validator.allValid()){
                                    this.state.dialogViewMode === 'ACCEPT' ?
                                    this.handleAccept() : this.state.dialogViewMode === 'REJECT' ? this.handleReject() : this.handleDelete();
                                } else {
                                    this.validator.showMessages();
                                    this.forceUpdate();
                                }
                                } else{ 
                                    this.validator.hideMessages();
                                    this.setState({ confirmationDialog: false })}
                            
                        }}
                        onHide={() => {
                            this.validator.hideMessages();
                            this.setState({ confirmationDialog: false });
                        }}

                        header={this.state.dialogViewMode === 'ACCEPT' ? t('leaveRequest.acceptHeader') :  this.state.dialogViewMode === 'REJECT' ? t('leaveRequest.rejectHeader') :  t('leaveRequest.deleteConfirmation')}
                    >
                        <InputTextComponent
                            id={`rejectionReason`}
                            name='rejectionReason'
                            label='Przyczyna odrzucenia'
                            colClass='col-md-12'
                            value={this.state.element.rejectionReason}
                            dataKey='id'
                            showLabel={true}
                            onChange={this.handleChange}
                            viewMode={'EDIT'}
                            rendered={this.state.dialogViewMode === 'REJECT'}
                            validator={this.validator}
                            validators='not_required|max:100'
                        />

                        <InputTextComponent
                            id={`leftDaysNumber`}
                            name='leftDaysNumber'
                            label='Liczba dni jaka pozostanie do wykorzystania'
                            colClass='col-md-12'
                            value={this.state.element.leftDaysNumber}
                            showLabel={true}
                            renderRequired
                            onChange={this.handleChange}
                            viewMode={'EDIT'}
                            rendered={this.state.dialogViewMode === 'ACCEPT' && (this.state.element.absenceReason?.reason === "Urlop wypoczynkowy" || this.state.element.absenceReason?.reason === "Urlop na żądanie" )}
                            validator={this.validator}
                            validators='required'
                        />

                    </YesNoDialog> : null}

            </React.Fragment>
        );
    }

}
LeaveRequestContainer.defaultProps = {
    backUrl: '#/employee-leave-request-list',
    backUrlCalendar: '#/employee-leave-request-view',
    cancelUrl: '/#/employee-leave-request/details',
    editUrl: '/#/employee-leave-request/edit',
    viewUrl: '/#/employee-leave-request/details/',
    lazy: true,
};

LeaveRequestContainer.propTypes = {
    backUrl: PropTypes.string,
    backUrlCalendar: PropTypes.string,
    cancelUrl: PropTypes.string,
    editUrl: PropTypes.string,
};
export default withRouter(withTranslation()(LeaveRequestContainer));
